export enum Language {
  CS = 'cs',
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  NL = 'nl',
  PL = 'pl',
  PT = 'pt',
}
